import React, { useState } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import { Field, Form, Formik } from "formik";
import CheckIcon from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import { callAPI } from "../../../../lib/common";
import MaterialTextField from "../../../../components/Formik/MaterialTextField";
import AppBar from "../../Components/AppBar";

const useStyles = makeStyles((theme) => ({
  form: {
    marginBottom: 0,
  },
  iconDone: {
    textAlign: "center",
    color: "green",
    "& .MuiSvgIcon-root": {
      fontSize: "3rem",
    },
  },
}));

export default () => {
  const [t] = useTranslation();
  const classes = useStyles();
  const [isUpdated, setIsUpdated] = useState(false);

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    callAPI("/ajax/user/update_password.php", "POST", values)
      .then((json) => {
        if (json.status == "OK") {
          setIsUpdated(true);
        }
        setSubmitting(false);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Change password</Trans>
      </PageHeader>
      <Container className={classes.root}>
        <Card>
          <CardContent>
            {isUpdated ? (
              <InfoUpdatedMessage />
            ) : (
              <ContactInfoForm handleSubmit={handleSubmit} />
            )}
          </CardContent>
        </Card>
      </Container>
    </MobilePage>
  );
};

const ContactInfoForm = ({ handleSubmit }) => {
  const [t] = useTranslation();
  const classes = useStyles();

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        password: "",
        reTypePassword: "",
      }}
      validate={(values) => {
        console.log("Validate");
        const errors = {};
        if (values.password.length < 5) {
          errors.password = t("The password is not long enough");
        }
        if (values.password != values.reTypePassword) {
          errors.reTypePassword = t("The passwords must match");
        }
        return errors;
      }}
    >
      {({ isSubmitting, errors, isValid, ...rest }) => {
        return (
          <Form className={classes.form}>
            <Box mb={3}>
              <Field
                name="password"
                type="password"
                label={t("New password")}
                required
                component={MaterialTextField}
              />
              <Field
                name="reTypePassword"
                type="password"
                label={t("Re-type Password")}
                component={MaterialTextField}
              />
            </Box>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isSubmitting || !isValid}
            >
              <Trans>Change password</Trans>
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

const InfoUpdatedMessage = () => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.iconDone}>
        <CheckIcon />
      </div>
      <p>
        <Trans>Your password was successfully updated.</Trans>
      </p>
    </div>
  );
};
